import Vue from 'vue';

Vue.component('fnb-stock-return-index', () =>
    import(/* webpackChunkName: 'fnb-stock-return-index' */ './stock-return-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/stock-return/index.js